import { FC } from 'react';
import { Control, FieldValues, useWatch } from 'react-hook-form';
import { Box, useThemeValue } from '@altermaind/web/ui';
import { Form } from '@/_shared/components/Form';
import { convertSizeToNumber } from '@/_shared/helpers';
import { useEmployeeCompleteQuiz } from '../hook/useEmployeeCompleteQuiz';

type Props = {
  currentStep: ReturnType<typeof useEmployeeCompleteQuiz>['currentStep'];
  control: Control<FieldValues>;
};
export const MultipleChoiceAnswer: FC<Props> = ({ currentStep, control }) => {
  const gapXS = convertSizeToNumber(`${useThemeValue('sizes', 'xs')}`) || 16;
  const values = useWatch({ control });

  const maxSelections = currentStep?.nextQuestion?.question.maxSelections || 1;
  const selectedCount = currentStep?.nextQuestion?.question.options?.reduce((count, option) => {
    const inputId = `multipleChoiceAnswer_${currentStep?.nextQuestion?.question.id}_${option.id}`;
    return values?.[inputId] === true ? count + 1 : count;
  }, 0);

  const isDisabled = (optionId: string) => {
    if (currentStep?.stepAlreadySubmitted) {
      return true;
    }
    const inputId = `multipleChoiceAnswer_${currentStep?.nextQuestion?.question.id}_${optionId}`;
    if (values?.[inputId] === true) return false;
    if (selectedCount) {
      return selectedCount >= maxSelections;
    }
    return false;
  };

  return (
    <Box display='flex' style={{ gap: gapXS }} flexDirection='column'>
      {/* TODO check */}
      {/* {currentStep.nextQuestion?.options */}
      {currentStep?.nextQuestion?.question.options
        ?.map((option, index) => {
          const inputId = `multipleChoiceAnswer_${currentStep?.nextQuestion?.question.id}_${option.id}`;
          return (
            <Box key={option.id || index}>
              <Form.FormCheckbox
                // @ts-ignore
                control={control}
                name={inputId}
                value={option.id}
                background={
                  // eslint-disable-next-line no-underscore-dangle
                  values?.[inputId] === true ? 'white' : undefined
                }
                iconColor={
                  // eslint-disable-next-line no-underscore-dangle
                  values?.[inputId] === true ? 'primary' : undefined
                }
                checked={
                  // eslint-disable-next-line no-underscore-dangle
                  values?.[inputId] === true
                }
                disabled={isDisabled(`${option.id}`)}
                containerCheckboxProps={{
                  px: 's',
                  py: 'xs',
                  bg: values?.[inputId] === true ? 'primary' : 'grey/dark/background',
                  borderRadius: 's',
                  display: 'flex',
                  flexDirection: 'row',
                  style: { cursor: 'pointer' },
                }}
                hasChildrenText={option.text}
              />
            </Box>
          );
        })
        .sort(() => Math.random() - 1) || null}
    </Box>
  );
};
